import exportBetslip from '@/betCalculation/exportBetslip'
import Vue from 'vue'
import { EventTypes } from '@altenar/models'
export class Betslip {
  public selectedOddsIds: number[] = []
  public selectedOdds: EventTypes.Odd[] = []
  public disabledIdxs: EventTypes.Odd[] = []
  public bankerIdxs: EventTypes.Odd[] = []
  public singleStakes: number[] = []
  public systemStakes: number[] = []
  public loading: boolean = false
  public multipleStake: number = 10
  public oddsChangeAction: string = 'Alwaysask'

  public export() {
    return exportBetslip(this)
  }

  public clearBetslip() {
    this.selectedOddsIds = []
    this.selectedOdds = []
    this.disabledIdxs = []
    this.bankerIdxs = []
    this.singleStakes = []
    this.systemStakes = []
    this.loading = false
    this.multipleStake = 10
    this.oddsChangeAction = 'Alwaysask'
  }

  public toggleOdd(odd: EventTypes.Odd) {
    const oddId = odd.Id
    const oddIdIdx = this.selectedOddsIds.indexOf(oddId)
    if (oddIdIdx === -1) {
      this.selectedOddsIds.push(oddId)
      this.selectedOdds.push(odd)
    } else {
      this.selectedOddsIds.splice(oddIdIdx, 1)
      this.selectedOdds.splice(oddIdIdx, 1)
    }
  }
}
export default Vue.observable(new Betslip())
